var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"widget",class:_vm.data.staticClass},[_c('div',{staticClass:"widget__title",domProps:{"textContent":_vm._s(_vm.props.title)}}),_c('div',{staticClass:"widget__inner"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }